import React from 'react';
import classes from './index.module.scss.js';

const LiraAdvContainer = ({ idForAd, withPlaceholder, className, inlineStyleForAd, ...divProps }) => {
    return (React.createElement("div", { className: `${classes['lira-container']} ${className ?? ''}`, ...divProps },
        React.createElement("div", { className: classes['lira-item'], id: idForAd, style: inlineStyleForAd }),
        withPlaceholder ? React.createElement("div", { className: classes['lira-placeholder'] }) : null));
};

export { LiraAdvContainer };
//# sourceMappingURL=index.js.map
